<template>
  <div>
    <b-modal
      footer="{null}"
      centered
      id="sim_card_gprs_deactivate"
      title="Désactiver Internet"
      hide-footer
       no-close-on-esc
      no-close-on-backdrop
    >
      <div>
        <div v-if="!is_ok">
          <div class="modal-header-wrap text-center">
            <i class="kgk-mtn-BW_Icons_MTNMoMo_GlobalConnect_4 modal-header-icon yellow-muted"></i>
            <h3>Désactiver Internet</h3>
            <p class="text-muted">
             Si vous souhaitez désactiver internter sur votre SIM, veuillez cliquez sur le bouton ci dessous.
            </p>
          </div>

          <div class="mt-3 mb-3 text-center">
            <button @click="go()" class="btn btn-primary">
              <b-spinner small v-if="is_loading" label="Loading..."></b-spinner>
              <span v-if="!is_loading">Envoyer</span>
            </button>
          </div>
        </div>

        <div v-if="is_ok" class="text-center modal-success-error-message">
          <i
            class="mdi mdi-check"
          ></i>
          <p class="text-muted"><b>Internet désactivé.</b> <br>Internet a été désactivé sur votre SIM.</p>
        </div>
      </div>
      <div></div>
    </b-modal>
  </div>
</template>

<script>
import { subscriber } from "@/services/";
export default {
  name: "SimCardDeActivateGPRS",
  mounted: async function () {},
  data: () => {
    return {
      is_ok: false,
      is_loading: false,
    };
  },
  methods: {
    go: async function () {
      if (!confirm(this.utils_get_config_message("deactive_gprs_prevent"))) {
        return;
      }
      this.is_loading = true;
      var response = await subscriber.gmcvs("gmcvs_deactivate");
      if (!_.isUndefined(response.deactivated)) {
        this.is_ok = true;
      }
      this.is_loading = false;
    },
  },
};
</script>